import React from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { Text } from '../../DesignSystem';
import { useAppState } from '../../../state';
import useDevices from '../../../hooks/useDevices/useDevices';

export default function AudioOutputList() {
  const { audioOutputDevices } = useDevices();
  const { activeSinkId, setActiveSinkId } = useAppState();
  const activeOutputLabel = audioOutputDevices.find(device => device.deviceId === activeSinkId)?.label;

  return (
    <div className="inputSelect">
      {audioOutputDevices.length > 1 ? (
        <FormControl fullWidth>
          <Text preset="Label2" tx="settings.audioOutput" gutterBottom />
          <Select onChange={e => setActiveSinkId(e.target.value as string)} value={activeSinkId} variant="outlined">
            {audioOutputDevices.map(device => (
              <MenuItem value={device.deviceId} key={device.deviceId}>
                {device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Text preset="Label2" tx="settings.audioOutput" />
          <Text preset="Label1" tx="settings.defaultAudioOutput" text={activeOutputLabel} />
        </>
      )}
    </div>
  );
}
